import {
  RealResultsRoot,
  ResultsContainer,
  ButtonWrapper,
  BadgeWrapper,
  HeaderContainer,
  Header,
  Subheader,
  Benefit,
  Result,
  Percentage,
} from './RealResults.styles'
import { Button } from 'components/Button'
import Image from 'next/image'
import badge from '../../../../../public/assets/home/quality-meats-badge.svg'
import { useTranslation } from 'hooks/useTranslation'
import { results } from './results'
import Link from 'next/link'
import { TranslationKeys } from 'locales/translationKeys'

type RealResultsProps = { showBadge?: boolean; cta?: TranslationKeys; ctaLink?: string; onCtaClick?: () => void }

export const RealResults = ({
  showBadge = false,
  cta = 'home:CTA',
  ctaLink = '/meal-plan',
  onCtaClick,
}: RealResultsProps) => {
  const { t } = useTranslation()

  return (
    <RealResultsRoot>
      <HeaderContainer addBadgeSpacing={showBadge}>
        {showBadge && (
          <BadgeWrapper>
            <Image width={130} height={130} src={badge} alt={t('home:real-results.badge')} />
          </BadgeWrapper>
        )}
        <Header>{t('home:real-results.title')}</Header>
        <Subheader>{t('home:real-results.subtitle')}</Subheader>
      </HeaderContainer>
      <ResultsContainer>
        {results.map(({ percent, benefit }, index) => (
          <Result key={index}>
            <Percentage>{t(percent)}</Percentage>
            <Benefit>{t(benefit)}</Benefit>
          </Result>
        ))}
      </ResultsContainer>
      <ButtonWrapper>
        {onCtaClick ? (
          <Button className='cta' onClick={onCtaClick}>{t(cta)}</Button>
        ) : (
          <Link passHref href={ctaLink}>
            <Button className='cta'>{t(cta)}</Button>
          </Link>
        )}
      </ButtonWrapper>
    </RealResultsRoot>
  )
}
